import { render } from "./CompanyAccount-DocumentsPoliciesAgreements.vue?vue&type=template&id=5e538b54&scoped=true"
import script from "./CompanyAccount-DocumentsPoliciesAgreements.vue?vue&type=script&lang=js"
export * from "./CompanyAccount-DocumentsPoliciesAgreements.vue?vue&type=script&lang=js"

import "./CompanyAccount-DocumentsPoliciesAgreements.vue?vue&type=style&index=0&id=5e538b54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e538b54"]])

export default __exports__